import { Component, Input } from '@angular/core';

interface FieldChange {
  field: string;
  from: unknown;
  to: unknown;
}

@Component({
  selector: 'app-route-configuration-changes',
  imports: [],
  templateUrl: './route-configuration-changes.component.html',
  styleUrl: './route-configuration-changes.component.scss',
})
export class RouteConfigurationChangesComponent {
  @Input() set configurationChanges(value: any) {
    this.rows = value
      ? Object.entries(value)
        .map(([field, change]) => ({
          field,
          from: (change as any).from,
          to: (change as any).to,
        }))
        .map(fieldChange => {
          if (fieldChange.field === 'schema') {
            const fromAttributes = fieldChange.from.classification.map(c => c.attribute);
            const fromLineType = fieldChange.from.style.lineType?.join('_');
            // eslint-disable-next-line max-len
            fieldChange.from = `(${fieldChange.from.style.color}-${fieldChange.from.style.width}-${fieldChange.from.style.opacity}-${fromLineType}), ${fromAttributes.join(', ')}, ${fieldChange.from.subRouteAttribute}`;
            const toAttributes = fieldChange.to.classification.map(c => c.attribute);
            const toLineType = fieldChange.to.style.lineType?.join('_');
            // eslint-disable-next-line max-len
            fieldChange.to = `(${fieldChange.to.style.color}-${fieldChange.to.style.width}-${fieldChange.to.style.opacity}-${toLineType}), ${toAttributes.join(', ')}, ${fieldChange.to.subRouteAttribute}`;
          }
          return fieldChange;
        })
      : [];
  }

  rows: FieldChange[] = [];
}
